export default "__VITE_ASSET__BhtH5y3K__"